import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import { POST_GUIDELINE } from 'modules/guidelines/actionTypes';

import assignment from './assignment';
import dashboard from './dashboard';
import details from './details';
import duplicate from './duplicate';
import update from './update';

export default combineReducers({
  // Whether a guideline creation request is in flight.
  creating: loading(POST_GUIDELINE),
  duplicate,
  update,
  details,
  dashboard,
  assignment,
});
